import { render, staticRenderFns } from "./CreateWADAClassification.vue?vue&type=template&id=3d8d857a&scoped=true&"
import script from "./CreateWADAClassification.vue?vue&type=script&lang=js&"
export * from "./CreateWADAClassification.vue?vue&type=script&lang=js&"
import style0 from "./CreateWADAClassification.vue?vue&type=style&index=0&id=3d8d857a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d857a",
  null
  
)

export default component.exports